<div id="drug-page-formulabar-container">
  <div id="drug-page-analysis-fbar" class="container-shadow">
    <!-- <app-subheader-formulabar></app-subheader-formulabar> -->
    <app-subheader-formulabar
      [hidden]="auditFormulabarVisible"
    ></app-subheader-formulabar>
    <app-audit-formulabar
      [hidden]="!auditFormulabarVisible"
    ></app-audit-formulabar>
  </div>
</div>
<div id="drug-page">
  <div id="drug-summary-container">
    <app-drug-summary> </app-drug-summary>
  </div>
  <div class="tabs-container">
    <nz-tabset nzType="card" (nzSelectedIndexChange)="onTabChange($event)">
      <div id="drug-sales-analysis-container">
        <nz-tab [nzTitle]="'Sales Analysis '">
          <app-drug-sales-analysis
            [activeTab]="tabNumber"
            (downloadPharmaExcel)="pharmaExportToExcel($event)"
          >
          </app-drug-sales-analysis>
        </nz-tab>
      </div>
      <nz-tab [nzTitle]="'Analyst Estimates'">
        <app-drug-distribution-analysis
          [activeTab]="tabNumber"
          (downloadPharmaExcel)="pharmaExportToExcel($event)"
        ></app-drug-distribution-analysis>
      </nz-tab>
    </nz-tabset>
  </div>
</div>
